import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6c6c46e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "section__header" }
const _hoisted_3 = { class: "section__title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "›", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "field-card__head" }
const _hoisted_8 = {
  key: 0,
  class: "field-card__tag"
}
const _hoisted_9 = { class: "field-card__name" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-card__arrow" }, "›", -1))
const _hoisted_11 = { class: "field-card__meta" }
const _hoisted_12 = { class: "field-card__stats" }
const _hoisted_13 = {
  key: 0,
  class: "field-card__phase-label"
}
const _hoisted_14 = {
  key: 0,
  class: "field-card__divider"
}
const _hoisted_15 = { class: "field-card__stat" }
const _hoisted_16 = {
  key: 0,
  class: "field-card__icon",
  viewBox: "0 0 16 16"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "#FF6A3D",
  d: "M8.6 1.2c.3 2.1-.8 3.3-1.9 4.5C5.6 6.9 4.5 8.1 4.5 10c0 2.2 1.6 4 3.6 4.3-1-.6-1.6-1.6-1.6-2.7 0-1.4 1-2.3 1.8-3.2.6 1 1.9 1.6 2.1 3.2.1.8-.2 1.8-.9 2.6 1.9-.4 3.3-2.1 3.3-4.2 0-3.9-2.8-6.1-4.2-8.8Z"
}, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "field-card__icon",
  viewBox: "0 0 16 16"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.3",
  "stroke-linejoin": "round",
  d: "M8 2.2a4 4 0 0 0-4 4V9L2.8 11.2h10.4L12 9V6.2a4 4 0 0 0-4-4ZM6.4 13.1a1.7 1.7 0 0 0 3.2 0"
}, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 0,
  class: "field-card__status field-card__status--ongoing"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "距截拍", -1))
const _hoisted_24 = { class: "field-card__status-number" }
const _hoisted_25 = {
  key: 1,
  class: "field-card__status field-card__status--preview"
}
const _hoisted_26 = { class: "field-card__status-number" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开拍", -1))
const _hoisted_28 = {
  key: 2,
  class: "field-card__status"
}
const _hoisted_29 = {
  key: 0,
  class: "field-card__auctions"
}
const _hoisted_30 = { class: "field-card__cover" }
const _hoisted_31 = { class: "field-card__price" }

import { computed } from "vue";
import { Image as VanImage } from "vant";
import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";
import { getCDNUrlWithoutImgInfo } from "@frontend/eros/dist/web";
import {
  getAuctionCover,
  getAuctionFieldCountdown,
  getAuctionFieldPhase,
  getAuctionPriceDisplay,
  toMilliseconds,
} from "../model";
import type {
  HotspotAuctionFieldItem,
  HotspotAuctionFieldSection,
} from "../model";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuctionFieldSection',
  props: {
    section: null,
    layout: null,
    now: null
  },
  emits: ["open-app"],
  setup(__props: any, { emit }: { emit: ({
  (event: "open-app"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  section: HotspotAuctionFieldSection;
  // carousel：多 section 横滑小卡片；list：仅拍场 section 纵向大卡片
  layout: "carousel" | "list";
  now: number;
}

dayjs.extend(calendar);





function buildStats(item: HotspotAuctionFieldItem, phase: string) {
  const { fieldInfo } = item;
  const count = {
    key: "count",
    value: Number(fieldInfo?.auctionCount || 0),
    unit: "件拍品",
  };
  const bids = {
    key: "bids",
    value: Number(fieldInfo?.bidsCount || 0),
    unit: "次出价",
  };
  const follow = {
    key: "follow",
    value: Number(fieldInfo?.followCount || 0),
    unit: "订阅",
  };

  // 预展只展示订阅数；横滑小卡片出价和订阅二选一，纵向大卡片都展示
  if (phase === "preview") return [count, follow];
  return props.layout === "carousel" ? [count, bids] : [count, bids, follow];
}

const cards = computed(() =>
  props.section.list.map((item) => {
    const { fieldInfo } = item;
    const phase = getAuctionFieldPhase(fieldInfo, props.now);
    const startText = dayjs(toMilliseconds(fieldInfo?.startTime)).calendar(
      null,
      {
        sameDay: "[今天] HH:mm",
        nextDay: "[明天] HH:mm",
        nextWeek: "MM-DD HH:mm",
        lastDay: "MM-DD HH:mm",
        lastWeek: "MM-DD HH:mm",
        sameElse: "MM-DD HH:mm",
      }
    );
    const [startDay, startClock] = startText.split(" ");

    return {
      id: fieldInfo?.id,
      name: fieldInfo?.fieldName,
      isBlind: fieldInfo?.auctionType === "BLIND",
      phase,
      stats: buildStats(item, phase),
      countdown: getAuctionFieldCountdown(fieldInfo, props.now),
      startDay,
      startClock,
      auctions: (item.auctionInfos || []).slice(0, 3).map((auction, index) => {
        const cover = getAuctionCover(auction);
        return {
          id: auction.id || `${fieldInfo?.id}-${index}`,
          cover: cover
            ? `${getCDNUrlWithoutImgInfo(cover)}!lfit_w1080_jpg`
            : "",
          ...getAuctionPriceDisplay(auction, fieldInfo, phase),
        };
      }),
    };
  })
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.section.title || "拍场"), 1),
      (__props.layout === 'carousel')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "section__action",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('open-app')))
          }, _hoisted_6))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(__props.layout === 'carousel' ? 'section__scroll' : 'section__list')
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(__props.layout === 'carousel' ? 'section__track' : 'section__stack')
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cards), (card) => {
          return (_openBlock(), _createElementBlock("article", {
            key: card.id,
            class: _normalizeClass(['field-card', `field-card--${__props.layout}`]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('open-app')))
          }, [
            _createElementVNode("div", _hoisted_7, [
              (card.isBlind)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "暗拍"))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_9, _toDisplayString(card.name), 1),
              _hoisted_10
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (card.phase === 'preview')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, " 预展 "))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.stats, (stat, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: stat.key
                  }, [
                    (index > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_15, [
                      (stat.key === 'bids')
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_16, _hoisted_18))
                        : (stat.key === 'follow')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_21))
                          : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        class: _normalizeClass({ 'field-card__stat-value': stat.key !== 'count' })
                      }, _toDisplayString(stat.value), 3),
                      _createElementVNode("span", null, _toDisplayString(stat.unit), 1)
                    ])
                  ], 64))
                }), 128))
              ]),
              (card.phase === 'ongoing')
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _hoisted_23,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.countdown, (part) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: `${card.id}-${part.unit}`
                      }, [
                        _createElementVNode("span", _hoisted_24, _toDisplayString(part.value), 1),
                        _createElementVNode("span", null, _toDisplayString(part.unit), 1)
                      ], 64))
                    }), 128))
                  ]))
                : (card.phase === 'preview')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("span", null, _toDisplayString(card.startDay), 1),
                      _createElementVNode("span", _hoisted_26, _toDisplayString(card.startClock), 1),
                      _hoisted_27
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_28, "已结束"))
            ]),
            (card.auctions.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.auctions, (auction) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: auction.id,
                      class: "field-card__auction"
                    }, [
                      _createElementVNode("div", _hoisted_30, [
                        (auction.cover)
                          ? (_openBlock(), _createBlock(_unref(VanImage), {
                              key: 0,
                              fit: "cover",
                              class: "field-card__cover-image",
                              src: auction.cover
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_31, _toDisplayString(auction.label) + " ¥" + _toDisplayString(auction.value), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ], 2)
    ], 2)
  ]))
}
}

})